"use client";

import React, { useState } from "react";
import { Plus, Minus, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServiceOfferings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: "How often should I service my lawn mower?",
    answer: "We recommend a full service at least once a year, ideally before the start of the cutting season. Regular maintenance prevents engine wear and ensures a clean cut for your lawn."
  }, {
    question: "Do you offer a collection and delivery service?",
    answer: "Yes, we provide a convenient collection and delivery service throughout Carlisle and the surrounding Cumbria areas for all types of machinery, including large ride-on mowers."
  }, {
    question: "How long does a typical repair take?",
    answer: "Most standard services and minor repairs are completed within 3-5 working days. During peak season, this may vary, but we always provide an estimated timeline upon inspection."
  }, {
    question: "Do you provide quotes before starting work?",
    answer: "Yes, we provide a transparent estimate after an initial diagnostic. We won't proceed with any major repairs without your explicit approval."
  }, {
    question: "Is your work guaranteed?",
    answer: "All our repairs come with a 90-day warranty on parts and labor, giving you peace of mind that your equipment has been serviced to the highest professional standards."
  }, {
    question: "Do you sell spare parts for DIY repairs?",
    answer: "We stock a wide range of common spare parts like spark plugs, filters, and oils. If we don't have it in stock, we can usually order it for next-day delivery."
  }];
  return <section ref={ref} className={`py-24 bg-background transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <span className="inline-block font-mono text-sm tracking-widest text-primary mb-6 uppercase">
                FREQUENTLY ASKED / 03
              </span>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-8 leading-[1.1]">
                Common Questions About Our Services
              </h2>
              <p className="text-muted-foreground text-lg mb-10 max-w-md leading-relaxed">
                Find answers to the most common queries regarding lawn mower repairs, servicing timelines, and our coverage across Cumbria.
              </p>
              <Link to="/RideOnMowerServicingRepairsPage" className="inline-flex items-center justify-center px-8 py-4 bg-primary text-primary-foreground rounded-lg font-medium transition-all hover:bg-primary/90 hover:shadow-lg group">
                Book a Service
                <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 space-y-4">
            {faqs.map((faq, index) => <div key={index} data-index={index} className="group">
                <div className={`border border-border rounded-lg transition-all duration-300 overflow-hidden bg-card ${openIndex === index ? "shadow-md border-primary/30" : "hover:border-primary/20"}`}>
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left cursor-pointer focus:outline-none">
                    <div className="flex items-start gap-4">
                      <span className="font-mono text-xs text-muted-foreground mt-1">
                        Q.{String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="font-serif text-xl text-foreground group-hover:text-primary transition-colors">
                        {faq.question}
                      </span>
                    </div>
                    <div className="ml-4 flex-shrink-0">
                      {openIndex === index ? <Minus className="size-5 text-primary" /> : <Plus className="size-5 text-muted-foreground group-hover:text-primary" />}
                    </div>
                  </button>
                  
                  <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                    <div className="px-6 pb-6 pt-0 ml-12">
                      <p className="text-muted-foreground leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}